<template>
  <div :class="cn('tw:rounded-md tw:bg-muted', props.class)" />
</template>

<script setup>
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false },
})
</script>
